// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, [2076], () => (__webpack_require__("./public/templates/modules/search_bar/auto_suggest.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
